import {Component, OnInit, inject} from '@angular/core';
import {FormControl, ReactiveFormsModule} from '@angular/forms';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatSelectModule} from '@angular/material/select';
import {CurrentSelection} from 'src/app/models/current-selection';
import {AgencyTagService} from 'src/app/services/agencytag.service';
import {FilterService} from 'src/app/services/filter.service';
import {SelectDataSource} from 'src/app/models/select';

@Component({
  selector: 'app-filter-turnover-risk',
  templateUrl: './filter-turnover-risk.component.html',
  styleUrls: ['./filter-turnover-risk.component.scss'],
  standalone: true,
  imports: [ReactiveFormsModule, MatFormFieldModule, MatSelectModule],
})
export class FilterTurnoverRiskComponent implements OnInit {
  private agencyTagService = inject(AgencyTagService);
  private filterService = inject(FilterService);

  turnoverRiskOptions: SelectDataSource[] = [
    {label: 'High', value: '3'},
    {label: 'Elevated', value: '2'},
    {label: 'Guarded', value: '1'},
    {label: 'Low', value: '0'},
  ];
  formControl = new FormControl([]);

  ngOnInit(): void {
    this.subscribeToFilterSelectionChanges();
  }

  updateTurnoverRiskFilter(): void {
    const selectedValues = this.formControl.value.map(
      (v) =>
        new CurrentSelection(
          v,
          this.turnoverRiskOptions.find((t) => t.value === v)?.label ?? v
        )
    );
    this.filterService.addMultiValuedFilter(
      'turnoverRiskStratification',
      selectedValues
    );
  }

  private subscribeToFilterSelectionChanges(): void {
    this.filterService.currentSelectionsChange$.subscribe(() => {
      const currentSelections = this.filterService.currentSelections
        .turnoverRiskStratification;
      if (!currentSelections) {
        this.formControl.reset([]);
      } else {
        this.formControl.patchValue(
          currentSelections.map((cs) => cs.filterValue)
        );
      }
    });
  }
}
